<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="6">
        <b-form-group>
          <b-input-group>
            <b-form-input
              type="text"
              placeholder="Search"
              @keyup="filterList"
              v-model="searchString"
            />

            <b-input-group-append>
              <b-input-group-text>
                <i
                  class="fa fa-times appendIcon clickIcon"
                  @click="resetSearch"
                ></i>
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col lg="3">
        <b-form-radio-group
          class="mr-3"
          id="radiosBtn"
          buttons
          button-variant="outline-primary"
          v-model="filterStatus"
          name="radiosBtn"
          @change.native="preprocessFilter"
        >
          <b-form-radio
            class="mx-0 standardizedShortWidth"
            style="cursor: pointer;"
            value="active"
            >Active</b-form-radio
          >
          <b-form-radio
            class="mx-0 standardizedShortWidth"
            style="cursor: pointer;"
            value="all"
            >Show All</b-form-radio
          >
        </b-form-radio-group>
      </b-col>
      <b-col lg="3">
        <div class="form-group form-actions float-right pb-2">
          <b-button
            class="mr-2"
            type="submit"
            size="md"
            variant="primary"
            @click="newEntity"
            v-if="n_user.n_current_user.IsSU"
          >
            <i class="fa fa-user-plus"></i>
            Create New Dealer
          </b-button>
        </div>
        <div>
          <StyledDialog
            @filterList="filterList"
            :CurrentObject="mySelected"
            EntityType="Dealer"
          >
            <div slot="header">
              <h2>{{ mySelected.Name }}</h2>
            </div>
            <div slot="details">
              <!-- <div>{{ mySelected.Title }}</div>
              <div>{{ mySelected.Email1 }}</div> -->
            </div>
            <span slot="entityType">Dealer</span>
          </StyledDialog>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-table
          @row-clicked="myRowClickHandler"
          :items="filteredObjects"
          :fields="fields"
          hover
          small
          fixed
          caption
          selectable
          select-mode="single"
          responsive="sm"
          selectedVariant="success"
          :current-page="currentPage"
          :per-page="perPage"
        >
          <template slot="Functions" slot-scope="data">
            <i
              v-if="n_user.n_current_user.IsSU"
              v-b-tooltip
              title="Delete"
              class="fa fa-trash-o"
              v-b-modal.modal-2
              @click="SetItemToDelete(data.item)"
            ></i>
          </template>
        </b-table>

        <nav v-show="isNavVisible">
          <b-pagination
            :per-page="perPage"
            :total-rows="totalRowsFiltered"
            v-model="currentPage"
            prev-text="Prev"
            next-text="Next"
            hide-goto-end-buttons
          />
        </nav>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import cTable from "@/views/base/Table.vue";
//import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
//import MyBaseTable from "@/components/base/MyBaseTable.vue";
import StyledDialog from "@/components/dialogs/StyledModal.vue";

export default {
  name: "DealerList",
  data: () => {
    return {
      fields: [
        {
          key: "Functions",
          label: "",
          sortable: false,
          thStyle: "width: 5%;",
          thClass: "ellipse_cell",
          tdClass: "ellipse_cell"
        },
        {
          key: "InternalDealerID",
          label: "BDS ID",
          sortable: true,
          thStyle: "width: 15%;",
          thClass: "ellipse_cell",
          tdClass: "ellipse_cell"
        },
        {
          key: "Name",
          label: "Name",
          sortable: true,
          thStyle: "width: 25%;",
          thClass: "ellipse_cell",
          tdClass: "ellipse_cell"
        },
        {
          key: "State",
          label: "State",
          sortable: true,
          thStyle: "width: 10%;",
          thClass: "ellipse_cell",
          tdClass: "ellipse_cell"
        },
        {
          key: "PostalCode",
          label: "Zip",
          sortable: true,
          thStyle: "width: 10%;",
          thClass: "ellipse_cell",
          tdClass: "ellipse_cell"
        },
        {
          key: "EmailMain",
          label: "Email",
          sortable: true,
          thStyle: "width: 20%;",
          thClass: "ellipse_cell",
          tdClass: "ellipse_cell"
        },
        {
          key: "PhoneMain",
          label: "Phone",
          sortable: true,
          thStyle: "width: 15%;",
          thClass: "ellipse_cell",
          tdClass: "ellipse_cell"
        }
      ],
      mySelected: {},
      currentPage: 1,
      perPage: 25,
      filteredObjects: [],
      searchString: "",
      filterStatus: "active"
    };
  },
  props: {},
  components: {
    cTable,
    StyledDialog
    //MyBaseTable
  },
  created() {
    this.myLoadComponent();
  },
  computed: {
    totalRows: function() {
      return this.$store.state.dealer.dealers.length;
    },
    totalRowsFiltered: function() {
      return this.filteredObjects.length;
    },
    isNavVisible: function() {
      return this.totalRowsFiltered > this.perPage;
    },
    ...mapState(["n_user", "emailtemplate", "dealer", "notification"]),
    ...mapActions("notification", ["add", "remove"])
  },
  // computed: mapState({
  //   users: state => state.n_user.n_users,
  //   items: state => state.n_user.n_users,
  //   itemsArray: state => state.n_user.n_users
  // }),
  updated() {
    this.incrementCount;
  },
  methods: {
    async myLoadComponent() {
      //if (!this.$store.state.player.players) {
      await this.$store.dispatch(
        "dealer/fetchRestrictedDealers",
        this.$store.state.n_user.n_current_user.UserProfileID
      );
      //}
      this.filterList();
    },
    myRowClickHandler(record, index) {
      // 'record' will be the row data from items
      // `index` will be the visible row number (available in the v-model 'shownItems')
      this.$store
        .dispatch("dealer/loadDealerEdit", record.DealershipID)
        .then(() => {
          this.$router.push({ path: "dealers/edit" });
        });
    },
    newEntity() {
      this.$store
        .dispatch("dealer/newDealer", this.createFreshObject())
        .then(() => {
          this.$router.push({ path: "dealers/edit" });
          //,
          //params: { id: this.event.id }
        })
        .catch(() => {
          console.log("There was a problem");
          //.dispatch('notification/add', this.event)
        });
    },
    preprocessFilter: function(event) {
      this.filterList();
    },
    filterList: function() {
      this.filteredObjects = this.$store.state.dealer.dealers;
      if (this.filterStatus === "active") {
        this.filteredObjects = this.filteredObjects.filter(
          dealer => dealer.Active == true
        );
      }

      this.filteredObjects = this.filteredObjects.filter(
        dealer =>
          dealer.Name.toLowerCase().indexOf(this.searchString.toLowerCase()) >
            -1 ||
          dealer.InternalDealerID.toLowerCase().indexOf(
            this.searchString.toLowerCase()
          ) > -1 ||
          dealer.State.toLowerCase().indexOf(this.searchString.toLowerCase()) >
            -1 ||
          dealer.PostalCode.toLowerCase().indexOf(
            this.searchString.toLowerCase()
          ) > -1
      );
    },
    resetSearch: function() {
      this.searchString = "";
      this.filterList();
    },
    SetItemToDelete(object) {
      this.mySelected = object;
    },
    createFreshObject() {
      return {
        DealershipID: -1,
        Name: "",
        Active: false
      };
    }
  },
  watch: {
    "$store.state.dealer.dealers.length": function(oldValue, newValue) {
      this.filterList();
    }
  }
};
</script>

<style scoped>
.my-tbl-function {
  width: 10% !important;
  color: red;
}
</style>
